import { useCallback, useContext } from "react";

import { toPromise } from "@apollo/client";
import { useRecoilState } from "recoil";

import { UserInfoContext } from "../../shared/api/contexts";
import { blizzardInitializedAtom } from "../../shared/state";

import { useInitializeBlizzard } from "./useInitializeBlizzard";

export const useAppAnalytics = (skip: boolean): { runInitializeAnalytics: () => void } => {
    const userInfo = useContext(UserInfoContext);
    const [analyticsInitialized, setAnalyticsInitialized] = useRecoilState(blizzardInitializedAtom);
    const initializeBlizzard = useInitializeBlizzard();

    const onInit = useCallback(() => {
        setAnalyticsInitialized(true);
    }, [setAnalyticsInitialized]);

    const runInitializeAnalytics = useCallback(() => {
        if (!skip && userInfo?.observable && !analyticsInitialized) {
            const promise = toPromise(userInfo.observable.filter((value) => !value.loading));
            initializeBlizzard(
                onInit,
                promise.then((res) => res.data.getUserProfile.userId),
            );
        }
    }, [skip, analyticsInitialized, initializeBlizzard, userInfo, onInit]);

    return { runInitializeAnalytics };
};
